import get from 'lodash/get'

const E = window.E || {}

export default (() => {
  return {
    isOnReactRouter: get(E, 'config.isMobile', false),
  }
})()
